import PrintInvoiceEditor from './editor';

const PrintInvoice = {
  Editor: PrintInvoiceEditor,
};

export default PrintInvoice;
